import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Footer from './component/footer';
import Header from './component/header';
import OfferPopup from '../../components/offers/OfferPopup';
import JadeChatWidget from '../../components/jadeChat/JadeChatWidget';
import FestiveSiteTheme from '../../views/home/festive/FestiveSiteTheme';

export default function AppChrome({
  loggedCustomer,
  isLoggedIn,
  isSaved,
  cities,
  getCity,
  getProperty,
  getWebsiteAppearance,
  properties,
  websiteAppearance,
}) {
  const { pathname, search } = useLocation();
  // Checkout opens its own login popup — keep the site-wide offer popups off it.
  const isCheckoutPage = pathname.startsWith('/request-booking') || pathname.startsWith('/c/');
  // Message links (/s/…, and the booking page they open with ?request=…) get straight to the task.
  // Offer pages already are the offer.
  const hidePromos = isCheckoutPage || pathname.startsWith('/s/') || pathname.startsWith('/offers') || /[?&]request=/.test(search);
  // Keep the AI chat off payment screens too.
  const hideJadeChat = isCheckoutPage || pathname.startsWith('/pay/') || pathname.startsWith('/payment');

  useEffect(() => {
    if (!cities?.length && getCity) {
      getCity();
    }
  }, [cities?.length, getCity]);

  useEffect(() => {
    if (getWebsiteAppearance) {
      getWebsiteAppearance();
    }
  }, [getWebsiteAppearance]);

  return (
    <>
      <FestiveSiteTheme />
      <Header
        key={loggedCustomer}
        loggedCustomer={loggedCustomer}
        isLoggedIn={isLoggedIn}
        isSaved={isSaved}
        cities={cities}
        getProperty={getProperty}
        properties={properties}
        websiteAppearance={websiteAppearance}
      />
      <Outlet />
      <Footer />
      {!hidePromos && <OfferPopup />}
      {!hideJadeChat && <JadeChatWidget />}
    </>
  );
}
